<template>
  <div class="import-template">
    <el-button
      @click="uploadTrigger"
      class="btn"
      size="small"
      icon="el-icon-upload2"
    >
      上传
    </el-button>
    <el-dialog
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
      custom-class="import-template-dialog"
    >
      <div slot="title" class="dialog-title">
        <span>模板上传</span>
      </div>
      <div class="sub-title">
        <span
          :class="active === 1 ? 'active' : 'disactive'"
          @click="active = 1"
        >
          题目设置
        </span>
        <span>|</span>
        <span
          :class="active === 2 ? 'active' : 'disactive'"
          @click="active = 2"
        >
          示例&帮助
        </span>
      </div>
      <p
        v-if="active === 1"
        style="margin-left: 10px;font-size: 12px;color: #999999;"
      >
        具体题目样式设置，请点击“示例&帮助”进行参考。
      </p>
      <div v-if="active === 2">
        <p style="margin-left:10px;font-size: 12px;color: #999999;">
          在题目标题后请通过[题目类型]填写准确的题目类型。如果需要备注可在题目下一行通过“备注：”进行填写，若不需要可不填；
        </p>
        <p style="margin-left:10px;font-size: 12px;color: #999999;">
          若本题必答，请通过填写“(必答)”（半角英文括号）样式进行操作。若非必答题，可不进行操作；
        </p>
        <p style="margin-left:10px;font-size: 12px;color: #999999;">
          题目数量最大支持256个，答案数量最大支持50个；
        </p>
        <p style="margin-left:10px;font-size: 12px;color: #999999;">
          题干最大支持300汉字，答案最大支持300汉字；
        </p>
        <p style="margin-left:10px;font-size: 12px;color: #999999;">
          若多次导入，则覆盖之前的内容，保留最后一次导入的内容（若仍有疑问，请点击：
          <a style="color:#409eff;text-decoration:underline" @click="helpCheck">
            查看帮助
          </a>
          ）
        </p>
      </div>
      <div class="template-translator">
        <div class="template-inner">
          <div
            v-show="active === 1"
            v-if="innerFocusStatus || inner"
            contenteditable
            class="textarea textarea-inner el-textarea__inner"
            id="divInner"
            @focus="innerFocus"
            @blur="innerBlur"
          ></div>
          <div
            v-else
            v-show="active === 1"
            contenteditable
            class="textarea textarea-inner el-textarea__inner"
            @focus="innerFocus"
            @blur="innerBlur"
          >
            <div class="inner-text" @click="uploadPrevent">
              <el-upload
                :show-file-list="false"
                class="upload-demo"
                drag
                action=""
                :http-request="
                  () => {
                    return false;
                  }
                "
                :on-change="fileDrop"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  请将文本文件（txt格式，仅支持UTF-8）拖至此处，或者直接将编辑好的文本内容复制至此处。
                </div>
              </el-upload>
            </div>
          </div>
          <div
            v-show="active === 2"
            class="textarea textarea-inner el-textarea__inner"
            id="divInnerDemo"
          ></div>
        </div>
        <div class="template-icon">
          <div>
            <img width="40px" src="@/assets/duiying.svg" alt="" />
            <p>对应</p>
          </div>
        </div>
        <div class="template-outer">
          <div id="divOuter" class="textarea el-textarea__inner">
            <div
              style="margin-bottom:30px;color: #333;"
              v-for="item in dealOuter.list"
              :key="item.id"
            >
              <template v-if="item.type === 1">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content">
                    <div v-for="item2 in item.a" :key="item2">
                      <el-radio :value="false">{{ item2 }}</el-radio>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item.type === 2">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content">
                    <div v-for="item2 in item.a" :key="item2">
                      <el-checkbox :value="false">{{ item2 }}</el-checkbox>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item.type === 3">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content">
                    <div v-for="item2 in item.a" :key="item2">
                      <el-radio :value="false">{{ item2 }}</el-radio>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item.type === 4">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content">
                    <el-input></el-input>
                  </div>
                </div>
              </template>
              <template v-if="item.type === 5">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content">
                    <div
                      v-for="item2 in item.a"
                      :key="item2"
                      style="margin-bottom:14px;"
                    >
                      <div style="margin-bottom:14px;">{{ item2 }}</div>
                      <el-input></el-input>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item.type === 6">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content">
                    <el-rate></el-rate>
                  </div>
                </div>
              </template>
              <template v-if="[9, 10, 11, 12].includes(item.type)">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content">
                    <img
                      width="60px"
                      v-if="item.type == 9"
                      src="@/assets/template/1.png"
                    />
                    <img
                      width="60px"
                      v-else-if="item.type == 10"
                      src="@/assets/template/2.png"
                    />
                    <img
                      width="60px"
                      v-else-if="item.type == 11"
                      src="@/assets/template/3.png"
                    />
                    <img
                      width="60px"
                      v-else-if="item.type == 12"
                      src="@/assets/template/4.png"
                    />
                  </div>
                </div>
              </template>
              <template v-if="item.type === 13">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-remark">
                    {{
                      `最少上传${
                        item.fileListLength === undefined
                          ? 1
                          : item.fileListLength
                      }张图片；${item.isDateWatermark ? '开启时间水印' : ''}`
                    }}
                  </div>
                  <div class="question-content pic">
                    <img
                      width="58px"
                      v-for="i in item.fileListLength === 0
                        ? 0
                        : item.fileListLength || 1"
                      :key="i"
                      src="@/assets/template/5.png"
                    />
                  </div>
                </div>
              </template>
              <template v-if="[14, 15].includes(item.type)">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content">
                    <el-time-select
                      :placeholder="
                        item.type == 15 ? '请选择月度' : '请选择时间'
                      "
                      style="width:100%;"
                      disabled
                    ></el-time-select>
                  </div>
                </div>
              </template>
              <template v-if="item.type === 16">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-remark">
                    {{
                      [
                        item.isDateWatermark && '开启时间水印',
                        item.isSetLocation && '开启实时定位'
                      ]
                        .filter(i => i)
                        .join(';')
                    }}
                  </div>
                  <div class="question-content">
                    <div
                      style="width: 100%;height: 100px;color: #1890ff;line-height: 100px;text-align: center;background: #efefef;"
                    >
                      点击获取地理位置
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item.type === 17">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content"></div>
                </div>
              </template>
              <template v-if="item.type === 19">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content">
                    <el-input
                      v-if="item.rule"
                      :placeholder="
                        item.errorMsg
                          ? `请输入${item.rule.minNum}-${item.rule.maxNum}的${
                              item.rule.numberType == 1 ? '小数' : '数字'
                            }`
                          : isNaN(item.rule.minNum) && isNaN(item.rule.maxNum)
                          ? ''
                          : `请输入${Number(item.rule.minNum).toFixed(
                              item.rule.numberType == 1 ? 2 : 0
                            )}-${Number(item.rule.maxNum).toFixed(
                              item.rule.numberType == 1 ? 2 : 0
                            )}的${item.rule.numberType == 1 ? '小数' : '数字'}`
                      "
                    ></el-input>
                    <el-input v-else></el-input>
                  </div>
                </div>
              </template>
              <template v-if="item.type === 20">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div
                    class="question-content"
                    style="text-align:center;line-height:76px;height: 76px;background:#F1F1F1;color:#ABABAB;font-size: 14px;"
                  >
                    请点击绘制您的姓名
                  </div>
                </div>
              </template>
              <template v-if="item.type === 22">
                <div>
                  <questionHeader
                    :valid="item.valid"
                    :index="item.index"
                    :require="item.require"
                    :title="item.title"
                    :errorMsg="item.errorMsg"
                  ></questionHeader>
                  <div class="question-remark">{{ item.remark }}</div>
                  <div class="question-content"></div>
                </div>
              </template>
              <template v-if="item.type === 999">
                <div>
                  <div :class="item.valid ? '' : 'invalid'">
                    <span>{{ item.index }}</span>
                    <span v-if="item.require">*</span>
                    <span>题型输入错误</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="isDisalbed" @click="confirm(true)">
          导入
        </el-button>
        <el-button @click="confirm(false)" type="primary" plain>关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="confirmShow"
      width="517px"
    >
      <div slot="title" class="confirm-title">
        <span>{{ confirmText.title }}</span>
      </div>
      <div v-html="confirmText.content"></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmShow = false">
          返回编辑
        </el-button>
        <el-button @click="confirmSubmit(confirmText.type)" type="primary">
          {{ confirmText.button }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="helpDialogShow"
      width="60%"
    >
      <div slot="title" class="confirm-title">
        <span>帮助</span>
      </div>
      <div>
        <p style="margin:0 40px;font-size: 12px;color: #999999;">
          格式说明：
        </p>
        <p style="margin:0 40px;font-size: 12px;color: #999999;">
          1. 请在题目后面添加题型标识，否则将无法识别题型；请使用[]进行标识。
        </p>
        <p style="margin:0 40px;font-size: 12px;color: #999999;">
          2.
          目前可识别的题型标识包括：[选择题]、[填空题]、[打分题]、[个人信息题]、[附件上传题]、[信息提交题]、[描述题]；
        </p>
        <p style="margin:0 40px;font-size: 12px;color: #999999;">
          3. 如果无法正确识别，请尝试在题目与题目之间加入空行；
        </p>
        <p style="margin:0 40px;font-size: 12px;color: #999999;">
          4. 请勿在选项与选项之间空行；
        </p>
      </div>
      <div class="help-container">
        <img src="@/assets/help2.png" alt="" />
      </div>
      <span v-if="false" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmShow = false">
          返回编辑
        </el-button>
        <el-button @click="confirmSubmit(confirmText.type)">
          {{ confirmText.button }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { questionType } from '@/config/staticData';
import { Message } from 'element-ui';
export default {
  props: {
    projectId: {
      type: Number,
      default: 0
    }
  },
  components: {
    questionHeader: {
      props: {
        valid: Boolean,
        require: Boolean,
        index: [String, Number],
        title: [String, Number],
        errorMsg: [String, Number]
      },
      render() {
        let { errorMsg, require, index, title, valid } = this;
        errorMsg = false; // 产品没有要求将提示显示在题目上，暂时隐藏
        return (
          <div>
            {errorMsg && (
              <div style="color:#ff6d0e;font-size:12px;">{errorMsg}</div>
            )}
            <div class={valid && !errorMsg ? '' : 'invalid'}>
              {require && <span style="margin-right:5px;">*</span>}
              <span>{index}</span>
              <span>{title}</span>
            </div>
          </div>
        );
      }
    }
  },
  data() {
    return {
      questionType,
      questionOrigin: '',
      helpDialogShow: false,
      active: 1,
      confirmType: false,
      confirmShow: false,
      questionSecondTypeData: {
        姓名题: 4,
        手机题: 2,
        邮箱题: 3
      },
      questionTypeData: {
        单选题: 1,
        多选题: 2,
        单选投票题: 3,
        单项填空题: 4,
        姓名题: 4,
        手机题: 4,
        邮箱题: 4,
        多项填空题: 5,
        打分题: 6,
        上传pdf: 9,
        上传word: 10,
        上传excel: 11,
        上传ppt: 12,
        上传图片: 13,
        时间题: 14,
        月度题: 15,
        定位题: 16,
        描述题: 17,
        数字填空题: 19,
        签名题: 20,
        姓名填空题: 22,
        真脑残题型都能输错: 999
      },
      dialogVisible: false,
      outer: [],
      outerDemo: [],
      inner: '',
      innerFocusStatus: false,
      test: `今天天气如何？[单选题](必答)
            备注：请如实作答
            晴天
            雨天
            雪天
            大风

            平时常用哪种题型？[多选题](必答)
            备注：
            单选
            多选
            填空
            附件上传


            请填写您的问题和建议[描述题]

            请填写您的问题和建议[多项填空题]
             单选
            多选
            填空
            附件上传`
    };
  },
  computed: {
    isDisalbed() {
      const outer = this.outer || [];
      return (
        outer.length === 0 ||
        outer.some(params => {
          return params.valid === false;
        })
      );
    },
    dealOuter() {
      // 根据题目列表，收集其中的错误信息
      if (this.active == 2) {
        return {
          list: this.outerDemo || [],
          errorMsg: [],
          submitErrorMsg: []
        };
      }
      const outer = this.outer || [];
      const errorMsg = outer.reduce(
        (pre, cur) => {
          const { type, title, a, rule, fileListLength } = cur;
          const { minNum: _minNum, maxNum: _maxNum, numberType } = rule || {};
          const [minNum, maxNum] = [+_minNum, +_maxNum];
          const curErrs = [];
          if (a.length > 50) {
            pre.submitErrSet.add(
              '题目数量超过256个或者某个答案数量超过50个，请重新编辑'
            );
          }
          if (title.length > 300 || a.some(text => text.length > 300)) {
            pre.submitErrSet.add('答案或者题干文字超过300汉字，请重新编辑');
          }
          if (type == 13) {
            if (fileListLength < 1 || fileListLength > 10) {
              curErrs.push(
                fileListLength < 1 ? '至少设置1张图片' : '最多设置10张图片'
              );
              pre.submitErrSet.add('上传图片数量最少1张，最多10张图片');
            }
          }
          if (type == 19) {
            const illegals = [
              [_minNum, _maxNum].filter(num => num === '' || num === undefined)
                .length == 1,
              numberType != 1 &&
                (/\./.test(`${minNum}`) || /\./.test(`${maxNum}`))
            ];
            if (illegals.some(status => status)) {
              cur.type = 1;
              cur.title = '题目格式不合法';
              cur.valid = false;
            } else {
              if (
                minNum < -99999999 ||
                minNum > 99999999 ||
                maxNum < -99999999 ||
                maxNum > 99999999
              ) {
                pre.submitErrSet.add('请输入-99999999-99999999区间的数值');
                curErrs.push('请输入-99999999-99999999区间的数值');
              }
              if (minNum >= maxNum) {
                curErrs.push('【前面数字】需小于【后面数字】');
                pre.submitErrSet.add('【前面数字】需小于【后面数字】');
              }
              if (numberType != 1 && Math.abs(maxNum - minNum) < 1) {
                curErrs.push('请输入差值为1的数值');
                pre.submitErrSet.add('请输入差值为1的数值');
              }
              if (
                numberType == 1 &&
                ((!/^(-){0,1}\d*(\.){0,1}(\d{0,2})$/.test(`${minNum}`) &&
                  minNum) ||
                  (!/^(-){0,1}\d*(\.){0,1}(\d{0,2})$/.test(`${maxNum}`) &&
                    maxNum))
              ) {
                curErrs.push('小数限制最大两位小数');
                pre.submitErrSet.add('小数限制最大两位小数');
              }
            }
          }
          if (cur.type == 17) {
            // 描述题 没有必填
            cur.require = false;
          }
          cur.errorMsg = curErrs.join(',');
          pre.questionErr.push(...curErrs);
          return pre;
        },
        {
          // 收集改变题目时候的提示
          questionErr: [],
          // 收集导入时候的提示
          submitErrSet:
            outer.length > 256
              ? new Set([
                  '题目数量超过256个或者某个答案数量超过50个，请重新编辑'
                ])
              : new Set()
        }
      );
      const { questionErr, submitErrSet } = errorMsg;
      this.showMessage(questionErr);
      return {
        list: outer,
        errorMsg: questionErr,
        submitErrorMsg: [...submitErrSet]
      };
    },
    confirmText() {
      if (this.confirmType) {
        return {
          title: '确认导入',
          content: `
            <p style="text-align:center;">您本次总共导入${this.outer.length}道题</p>
            <p>是否确认导入本次编辑的相关内容。导入后，之前导入的内容将会覆盖。</p>`,
          button: '确认导入',
          type: true
        };
      } else {
        return {
          title: '确认关闭',
          content:
            '您当前问卷编辑页面内有内容，是否确认关闭？关闭后，此次编辑内容将不会保存',
          button: '确认关闭',
          type: false
        };
      }
    }
  },
  mounted() {
    this.outerDemo = this.questionSplitter(this.test);
  },
  watch: {
    questionOrigin: {
      handler() {
        this.outer = this.questionSplitter(this.questionOrigin);
      }
    }
  },
  methods: {
    // 传入错误提示的集合，同步按序一次性弹出
    showMessage(msgList) {
      if (!Array.isArray(msgList)) {
        return;
      }
      const showMsg = msg => {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve();
            Message({ message: msg, type: 'error' });
          }, 100);
        });
      };
      const fn = async () => {
        for (let i = msgList.length; i > 0; ) {
          await showMsg(msgList[msgList.length - i--]);
        }
      };
      fn();
    },
    uploadPrevent(event) {
      event.preventDefault();
      this.innerFocus();
      window.setTimeout(function() {
        document.getElementById('divInner').focus();
      }, 0);
    },
    helpCheck() {
      this.helpDialogShow = true;
    },
    clearData() {
      this.inner = '';
      this.outer = '';
      this.active = 1;
      this.questionOrigin = '';
    },
    confirmSubmit(type) {
      if (type) {
        try {
          if (this.outer.filter(i => i.type == 16).length > 1) {
            Message({ message: '定位题最多添加一道', type: 'error' });
            this.confirmShow = false;
            return;
          }
        } catch (error) {
          console.warn(error);
        }

        let emitData = [];
        this.$sentry.captureMessage(`问卷导入-${this.projectId}`, {
          level: 'info',
          contexts: {
            data: {
              inner: document.getElementById('divInner').innerText,
              json: JSON.stringify(this.outer)
            }
          }
        });

        (this.outer || []).map((q, index) => {
          let rule = q.rule || {};
          // 数字填空题
          if (q.type === 19) {
            // 小数情况，将数字处理为小数形式
            // 在这儿处理，是为了不影响到题目中一些判断逻辑，比如没开启小数，但是输入了小数的时候
            rule = {
              numberType: 0, // 默认使用0，防止丢失！！！！
              ...rule,
              minNum: isNaN(Number(rule.minNum))
                ? ''
                : rule.numberType == 1
                ? Number(rule.minNum).toFixed(2) + ''
                : Number(rule.minNum) + '',
              maxNum: isNaN(Number(rule.maxNum))
                ? ''
                : rule.numberType == 1
                ? Number(rule.maxNum).toFixed(2) + ''
                : Number(rule.maxNum) + ''
            };
          }

          const obj = {
            isMustFill: Number(q.require),
            type: q.type,
            list: q.a,
            title: q.title,
            remark: q.remark,
            id: `${Date.now() + parseInt(Math.random() * 1000) + index}`,
            weight: index + 1,
            rule: rule,
            fileListLength: q.fileListLength || 1,
            [q.type == 13 ? 'isDateWatermark' : '_c']: Number(
              q.isDateWatermark
            ),
            [q.type == 16 ? 'isOpenPicWatermark' : '_c']: Number(
              q.isDateWatermark
            ),
            [q.type == 16 ? 'isSetLocation' : '_l']: Number(q.isSetLocation)
          };
          delete obj._c;
          emitData.push(obj);
        });
        this.$emit('questionListUpdate', emitData);
        this.dialogVisible = false;
        this.confirmShow = false;
        this.clearData();
      } else {
        this.dialogVisible = false;
        this.confirmShow = false;
        this.clearData();
      }
    },
    confirm(type) {
      if (type) {
        // 点击导入
        // 如果有全局错误，则提示弹出提示框
        const { submitErrorMsg } = this.dealOuter;
        if (submitErrorMsg.length > 0) {
          this.showMessage(submitErrorMsg);
          return;
        }
      }
      this.confirmType = type;
      if (!type && this.outer.length === 0) {
        this.dialogVisible = false;
        this.confirmShow = false;
        this.clearData();
      } else {
        this.confirmShow = true;
      }
    },
    questionSplitter(text) {
      let target;
      //按换行符分割数组
      target = text.split(/\r\n|\n|\r/g);
      //声明题目数组
      let q = [];
      //声明题号
      let count = 0;
      //问题标记
      let isQ = true;
      //上一行为空标记
      let lastEmpty = false;
      //分割数组遍历
      target.map(params => {
        //去空格
        let trimParams = params.trim();
        //规避空指针异常
        if (!q[count]) {
          q[count] = {
            a: [],
            title: '',
            remark: '',
            type: '',
            require: false,
            index: '',
            valid: true
          };
        }
        //处理空行
        if (trimParams === '') {
          //上一行不为空则题号+1且标记上一行为空
          //上一行为空则读取下一行
          if (!lastEmpty) {
            count++;
            lastEmpty = true;
          }
          //题目标题标记重置
          isQ = true;
          //处理非空行
        } else {
          q[count].index = count + 1;
          lastEmpty = false;
          //处理问题
          if (isQ) {
            //匹配题型
            let type = trimParams.match(
              /(?:\[)([\u4e00-\u9fa5|word|ppt|pdf|excel]{0,})(?=\])/g
            );
            //没有题型则不合法
            if (!type) {
              q[count].type = 1;
              q[count].title = '题目格式不合法';
              q[count].valid = false;
              return;
            } else {
              type[0] = type[0].replace('[', '');
            }
            q[count].type = this.questionTypeData[type[0]];
            q[count].secondType =
              this.questionSecondTypeData[type[0]] || q[count].type;
            if (!q[count].type) {
              q[count].type = 999;
              q[count].valid = false;
            }
            //匹配必答， 只匹配最后一次出现的
            let requireType = trimParams.match(
              /(?:\()([\u4e00-\u9fa5|word|ppt|pdf|excel]{0,})(?=\)*$)/g
            );
            if (requireType) {
              requireType[0] = requireType[0].replace('(', '');
            }
            if ((requireType || [])[0] === '必答') {
              q[count].require = true;
            }
            //去掉题型和必答字样
            q[count].title = trimParams
              .replace(
                /(\()([\u4e00-\u9fa5|word|ppt|pdf|excel]{0,})(\)*$)/g,
                ''
              )
              .replace(/(\[)([\u4e00-\u9fa5|word|ppt|pdf|excel]{0,})(\])/g, '');
            //问题标记否
            isQ = false;
            //处理非问题
          } else {
            const config = [
              {
                name: '处理备注',
                reg: /^备注：(.*)/,
                fn: (obj, trimParams, reg) => {
                  obj.remark = `${(trimParams.match(reg) || [])[1]}`.slice(
                    0,
                    50
                  );
                }
              },
              {
                name: '处理图片配置',
                reg: /^最少上传(-{0,1}\d{1,})张图片(;|；)*(开启时间水印)*|^(开启时间水印)/,
                fn: (obj, trimParams, reg) => {
                  const [
                    ,
                    fileListLength = 1,
                    ,
                    isDateWatermark,
                    _isDateWatermark
                  ] = trimParams.match(reg) || [];
                  obj.fileListLength = Number(fileListLength);
                  obj.isDateWatermark = !!(isDateWatermark || _isDateWatermark);
                }
              },
              {
                name: '处理定位题配置',
                reg: /^【(开启时间水印|开启实时定位)(?=;)?(;?)((?<=;)(开启时间水印|开启实时定位))?】$/,
                fn: (obj, trimParams, reg) => {
                  const [, str1 = '', , str2] = trimParams.match(reg) || [];
                  obj.isDateWatermark =
                    str1 === '开启时间水印' || str2 === '开启时间水印';
                  obj.isSetLocation =
                    str1 === '开启实时定位' || str2 === '开启实时定位';
                }
              },
              {
                name: '处理数字填空题配置',
                reg: /^数字范围【(-{0,1}\d*.{0,1}\d*)[，|,](-{0,1}\d*.{0,1}\d*)】(;|；)*(允许输入小数)*|(允许输入小数)/,
                fn: (obj, trimParams, reg) => {
                  let [, min, max, , canInputDecimal1, canInputDecimal2] =
                    trimParams.match(reg) || [];
                  const canInputDecimal = canInputDecimal1 || canInputDecimal2;
                  obj.rule = {
                    minNum: min + '',
                    maxNum: max + '',
                    numberType: canInputDecimal ? 1 : 0
                  };
                }
              }
            ];
            const textDealConfig = config.find(({ reg }) =>
              reg.test(`${trimParams}`)
            ) || { fn: () => {}, reg: '' };
            if (textDealConfig.reg) {
              textDealConfig.fn &&
                textDealConfig.fn(q[count], trimParams, textDealConfig.reg);
            } else {
              q[count].a.push(trimParams);
            }
          }
        }
      });

      return q.filter(({ title }) => title !== '');
    },
    fileDrop(file) {
      const reader = new FileReader();
      reader.readAsText(file.raw, 'utf8');
      reader.onload = () => {
        // 去掉 起始的多余空行
        let text = reader.result.replace(/(^(\n|\rn|\r)+)/g, '');
        this.inner = text;
        this.$nextTick(() => {
          document.getElementById('divInner').innerText = text;
          this.questionOrigin = text;
        });
      };
    },
    innerBlur(event) {
      let target = event.target;

      // 移除前面的空行
      target.innerHTML = target.innerHTML.replace(/^(<br>)+/g, '');

      target.innerHTML = target.innerHTML.replace(
        /(^(<div><br><\/div>)+)/g,
        ''
      );

      target.innerHTML = target.innerHTML.replace(
        /(^(<div><.+><br><\/\w+><\/div>)+)/g,
        ''
      );

      // 光标在 题目之前删除为空 的时候 会出现 <div><span>一些字段</span><br/></div>
      function rec(dom) {
        let children = [];
        [].push.apply(children, dom.children);
        if (children.length) {
          if (children.length > 1) {
            if (
              dom.firstChild.nodeName === 'SPAN' &&
              dom.lastChild.nodeName === 'BR'
            ) {
              let str = dom.firstChild.innerText;
              dom.removeChild(dom.firstChild);
              dom.removeChild(dom.lastChild);
              dom.innerHTML = str;
            }
          }
          children.forEach(rec);
        }
      }

      rec(target);

      let trimString = target.innerText.replace(/\r\n|\n|\r/g, '');
      if (trimString.length === 0) {
        this.inner = '';
        document.getElementById('divInner').innerText = '';
        this.questionOrigin = '';
        this.innerFocusStatus = false;
        return;
      }
      this.inner = target.innerText;
      this.questionOrigin = this.inner;
      this.innerFocusStatus = false;
    },
    innerFocus() {
      this.innerFocusStatus = true;
    },
    uploadTrigger() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        document.getElementById('divInnerDemo').innerText = this.test;
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="scss">
.import-template {
  .invalid {
    span {
      color: #ff6d0e;
    }
  }
  .el-radio__label,
  .el-checkbox__label {
    white-space: pre-wrap;
  }
  .help-container {
    text-align: center;
    -webkit-user-drag: none;
  }
  .active {
    color: #409eff;
  }
  .disactive {
    cursor: pointer;
    text-decoration: underline;
  }
  .el-upload {
    cursor: unset;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
  .textarea {
    width: 345px;
    min-height: 400px !important;
  }
  .textarea-inner {
  }
  .inner-text {
    //   margin-top:30%;
    text-align: center;
    i {
      font-size: 40px;
    }
  }
  .el-upload-dragger {
    cursor: unset;
    padding-top: 100px;
    width: 270px;
    height: 380px;
    border: none;
  }
  &-dialog {
    .el-dialog__footer {
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.template-translator {
  padding-top: 20px;
  display: flex;
  justify-content: space-around;
  .template-icon {
    line-height: 40px;
    padding-top: 20%;
    flex-shrink: 0;
    p {
      text-align: center;
    }
  }
}

.dialog-title {
  // background-color: #409eff;
  color: #303133;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  padding-top: 30px;
}
.confirm-title {
  background-color: #ffffff;
  color: #303133;
  text-align: center;
  padding-top: 30px;
  font-weight: 500;
  font-size: 18px;
  line-height: 1;
}
.sub-title {
  text-align: center;
}
.btn {
  color: #eb9319;
  border-color: #eb9319;
  &:hover,
  &:focus {
    color: #eb9319;
    border-color: #eb9319;
    background-color: rgba($color: #eb9319, $alpha: 0.3);
  }
}
.question {
  &-content {
    margin-top: 14px;
    &.pic {
      display: flex;
      flex-wrap: wrap;
      img {
        margin-right: 8px;
        margin-bottom: 8px;
      }
    }
  }
  &-remark {
    font-size: 14px;
    color: #909399;
    line-height: 1;
    margin-top: 14px;
  }
}
.dialog-footer {
  width: 100%;
  text-align: center;
}
</style>
